module.exports = __webpack_public_path__ + "static/img/12345.3ad0a45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/nxzw/12345.jpg
// module id = Ns5O
// module chunks = 0